import React, { useEffect, useRef, useState } from "react";
import MediaPicker from "../../form/media-picker/desktop/MediaPicker";
import { useDispatch } from "react-redux";
import { ProductInterface } from "../../../types/common.types";
import ModalProductUpdate from "../../form/ModalProductUpdate";
import { clearMediaSelection } from "../../../redux/slices/ProductState";
import { Box, IconButton, Popover } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GetMedia } from "../../../helpers/xhrHelper";

interface ProductEdit {
  modalMode: number;
  product: ProductInterface;
  productType: number;
}
const WriteProduct = (props: ProductEdit) => {
  const { product, productType } = props;
  const dispatch = useDispatch();
  const [mediaPicker, showMediaPicker] = useState<boolean>(false);
  const hasFetchedMedia = useRef(false);

  const id = !!mediaPicker ? "simple-popover" : undefined;

  useEffect(() => {
    if (!hasFetchedMedia.current) {
      GetMedia(dispatch, "product-photos", productType);
      hasFetchedMedia.current = true;
    }
    return () => {
      dispatch(clearMediaSelection());
    };
  }, [dispatch, productType]);

  return (
    <Box>
      <Box>
        <ModalProductUpdate
          productType={productType}
          activeProduct={product}
          showMediaPicker={showMediaPicker}
        />
      </Box>
      <Popover
        id={id}
        open={mediaPicker}
        onClose={() => showMediaPicker(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        disablePortal
        sx={{
          zIndex: 1000,
          maxHeight: "500px",
          "& .MuiPopover-paper": {
            bgcolor: "#16100f",
            color: "#f0ece8",
            border: "1px solid rgba(131, 60, 65, 0.22)",
            borderRadius: "10px",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={() => showMediaPicker(false)}
          sx={{
            position: "absolute",
            right: 15,
            top: 15,
            zIndex: 1000,
            backgroundColor: "#1f1615",
            borderRadius: "7px",
            border: "1px solid rgba(131, 60, 65, 0.28)",
            "&:hover": {
              backgroundColor: "rgba(131, 60, 65, 0.2)",
            },
            color: "#f0ece8",
          }}
        >
          <CloseIcon sx={{ fontSize: "14px" }} />
        </IconButton>
        <MediaPicker />
      </Popover>
    </Box>
  );
};

export default WriteProduct;
